module.exports = __webpack_public_path__ + "static/media/14.00ce9f15.jpg";